import { render, staticRenderFns } from "./programItem.vue?vue&type=template&id=444ce31a"
import script from "./programItem.vue?vue&type=script&lang=js"
export * from "./programItem.vue?vue&type=script&lang=js"
import style0 from "./programItem.vue?vue&type=style&index=0&id=444ce31a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports